var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 143,
    viewBox: "0 0 143 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.042 85.2344C103.94 85.2344 107.469 86.8147 110.024 89.3692C112.579 91.9238 114.159 95.4531 114.159 99.351C114.159 103.249 112.579 106.778 110.024 109.333C107.469 111.887 103.94 113.468 100.042 113.468C96.1444 113.468 92.6152 111.887 90.0606 109.333C87.506 106.778 85.9258 103.249 85.9258 99.351C85.9258 95.453 87.506 91.9238 90.0606 89.3692C92.6152 86.8147 96.1445 85.2344 100.042 85.2344Z",
    fill: "#666363"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5319_3106)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.191 5.58393L107.191 5.57992L109.332 5.34219C111.714 5.07751 113.868 6.80086 114.132 9.18272C114.17 9.52323 114.159 9.35453 114.159 9.67203V78.0654C114.159 80.4653 112.212 88.994 109.812 88.994C107.412 88.994 105.465 87.047 105.465 84.6471V14.5151L57.9205 19.7979V97.1442C57.9205 99.5443 55.9735 101.491 53.5735 101.491C51.1736 101.491 49.2266 99.5443 49.2266 97.1442V15.9109C49.2266 13.6287 50.9905 11.8281 53.2246 11.5799L107.191 5.58393Z",
    fill: "#BCE0F5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7229 95.9219C47.6425 95.9219 51.1915 97.5109 53.7604 100.08C56.3293 102.649 57.9184 106.198 57.9184 110.117C57.9184 114.037 56.3293 117.586 53.7604 120.155C51.1915 122.724 47.6425 124.313 43.7229 124.313C39.8032 124.313 36.2542 122.724 33.6853 120.155C31.1165 117.586 29.5273 114.037 29.5273 110.117C29.5273 106.198 31.1165 102.649 33.6853 100.08C36.2542 97.5109 39.8032 95.9219 43.7229 95.9219Z",
    fill: "#666363"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5319_3106",
    x: 45.2266,
    y: 5.31543,
    width: 72.9336,
    height: 104.176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5319_3106"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5319_3106",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListening);
export default __webpack_public_path__ + "static/media/listening.5c55d9e11c1db3a6cedc3ec77a6a6dc1.svg";
export { ForwardRef as ReactComponent };